var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumberTwoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#5463FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3418 28H14.9863V26.6426L18.8047 22.7656C19.5143 22.0495 20.11 21.4115 20.5918 20.8516C21.0801 20.2917 21.4512 19.7415 21.7051 19.2012C21.959 18.6543 22.0859 18.0553 22.0859 17.4043C22.0859 16.597 21.8451 15.9818 21.3633 15.5586C20.888 15.1289 20.2598 14.9141 19.4785 14.9141C18.7949 14.9141 18.1895 15.0312 17.6621 15.2656C17.1348 15.5 16.5944 15.832 16.041 16.2617L15.1719 15.168C15.5495 14.849 15.9596 14.5658 16.4023 14.3184C16.8516 14.071 17.3301 13.8757 17.8379 13.7324C18.3522 13.5892 18.8991 13.5176 19.4785 13.5176C20.3574 13.5176 21.1159 13.6706 21.7539 13.9766C22.3919 14.2826 22.8835 14.7188 23.2285 15.2852C23.5801 15.8516 23.7559 16.5254 23.7559 17.3066C23.7559 18.0618 23.6061 18.765 23.3066 19.416C23.0072 20.0605 22.5872 20.7018 22.0469 21.3398C21.5065 21.9714 20.875 22.6419 20.1523 23.3516L17.0469 26.4473V26.5156H24.3418V28Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberTwoIcon);
export default __webpack_public_path__ + "static/media/NumberTwoIcon.11ccb57820cea29904bf0686e7efe97b.svg";
export { ForwardRef as ReactComponent };